import axios from 'axios'

const savedVistaActiva = localStorage.getItem('vista-difusion-activa') ?
  JSON.parse(localStorage.getItem('vista-difusion-activa')) : null
const allVistas = {}
if (savedVistaActiva) {
  allVistas[savedVistaActiva.id] = savedVistaActiva
}

export default {
  state: {
    vistaActivaId: savedVistaActiva ? savedVistaActiva.id : null,
    showSideNav: false,
    allVistas: allVistas,
    loadedAllVistas: false,
    publicacionesDisponibles: null,

    //Cosas de productos relacionados a K10 que van a dar F3
    productoToF3: null,
    costoF3: 0,

    patrocinadorK10Data: null,
    vistasDifusionRS: {},

    //Comentarios
    unsavedComentarioData: null,
    errorSavingComment: false,
    replyingToComment: null,
    intrinsicReplyTo: null,

    //Reacciones
    reaccionesPub: {},
    reaccionesCom: {}
  },
  mutations: {
    SET_VISTA_ACTIVA_ID(state, id) {
      state.vistaActivaId = id
    },
    SET_SHOW_SIDE_NAV(state, bool) {
      state.showSideNav = bool
    },
    SET_ALL_VISTAS(state, obj) {
      state.allVistas = obj
    },
    SET_VISTA_IN_ALL_VISTAS(state, vista) {
      state.allVistas[vista.id] = vista
    },
    SET_LOADED_ALL_VISTAS(state, bool) {
      state.loadedAllVistas = bool
    },
    SET_PUBK10_DISPONIBLES(state, number) {
      state.publicacionesDisponibles = number
    },

    //Cosas de productos relacionados a K10 que van a dar F3
    SET_PRODUCTO_TO_F3(state, orden) {
      state.productoToF3 = orden
    },
    SET_COSTO_F3(state, costo) {
      state.costoF3 = costo
    },

    SET_PATROCINADOR_K10_DATA(state, data) {
      state.patrocinadorK10Data = data
    },
    SET_VISTAS_DIFUSION_RS(state, vistas) {
      state.vistasDifusionRS = vistas
    },
    ADD_VISTAS_DIFUSION_RS(state, newVistas) {
      state.vistasDifusionRS = {...state.vistasDifusionRS, ...newVistas}
    },

    // Comentarios
    SET_UNSAVED_COMENTARIO_DATA(state, data) {
      state.unsavedComentarioData = data
    },
    SET_ERROR_SAVING_COMMENT(state, bool) {
      state.errorSavingComment = bool
    },
    SET_REPLYING_TO_COMMENT(state, obj) {
      state.replyingToComment = obj
    },
    SET_INTRINSIC_REPLY_TO(state, obj) {
      state.intrinsicReplyTo = obj
    },

    //Reacciones
    SET_REACCIONES_PUB(state, reacciones) {
      state.reaccionesPub = {...state.reaccionesPub, ...reacciones}
    },
    SET_REACCIONES_COM(state, reacciones) {
      state.reaccionesCom = {...state.reaccionesCom, ...reacciones}
    },
    SET_REACCION_TO_PUB(state, payload) {
      state.reaccionesPub[payload.publicacionId] = {...state.reaccionesPub[payload.publicacionId], ...payload.reaccion}
    },
    SET_REACCION_TO_COM(state, payload) {
      state.reaccionesCom[payload.comentarioId] = {...state.reaccionesCom[payload.comentarioId], ...payload.reaccion}
    },
    DELETE_REACCIONES(state) {
      state.reaccionesPub = {}
      state.reaccionesCom = {}
    }
  },
  getters: {
    vistaActivaId: state => state.vistaActivaId,
    vistaDifusionActiva: state => state.vistaActivaId ? state.allVistas[state.vistaActivaId] : null,
    showSideNav: state => state.showSideNav,
    allVistas: state => state.allVistas,
    loadedAllVistas: state => state.loadedAllVistas,
    pubK10Disponibles: state => state.publicacionesDisponibles,

    //Cosas de saldo K10
    productoToF3: state => state.productoToF3,
    costoF3: state => state.costoF3,

    patrocinadorK10Data: state => state.patrocinadorK10Data,
    vistasDifusionRS: state => state.vistasDifusionRS,

    // Comentarios
    unsavedComentarioData: state => state.unsavedComentarioData,
    errorSavingComment: state => state.errorSavingComment,
    replyingToComment: state => state.replyingToComment,
    intrinsicReplyTo: state => state.intrinsicReplyTo,

    // Reacciones
    reaccionesPub: state => state.reaccionesPub,
    reaccionesCom: state => state.reaccionesCom,
  },
  actions: {
    updateVistaInAllVistas({ state, commit, dispatch }, vista) {
      commit('SET_VISTA_IN_ALL_VISTAS', {...(state.allVistas[vista.id] || {}), ...vista})
      if (vista.id === state.vistaActivaId) {
        dispatch('updateSavedVistaActiva')
      }
    },
    updateVistaActivaId({ commit, dispatch }, id) {
      commit('SET_VISTA_ACTIVA_ID', id)
      dispatch('updateSavedVistaActiva')
    },
    updateSavedVistaActiva({ state }) {
      if (state.vistaActivaId && state.allVistas[state.vistaActivaId]) {
        localStorage.setItem('vista-difusion-activa', JSON.stringify(state.allVistas[state.vistaActivaId]))
      } else {
        localStorage.removeItem('vista-difusion-activa')
      }
    },
    setAllVistas({ commit, dispatch }, obj) {
      commit('SET_ALL_VISTAS', obj)
      commit('SET_LOADED_ALL_VISTAS', true)
      dispatch('updateSavedVistaActiva')
    },
    async saveComment({ state, commit }) {
      const params = {...state.unsavedComentarioData}
      if (state.unsavedComentarioData.newComment) {
        delete params.id
      }
      delete params.newComment

      await axios.post(`api/v2/koinonia10/influencer/comentario/save.json`,params).
      then(async resp => {
        if (resp.data.ok) {
          const {id, comentario_id, publicacion_id} = state.unsavedComentarioData
          commit('SET_EVENT_BUS', {
            type: 'k10-comentario-saved',
            timestamp: Date.now(),
            data: {newId: resp.data.id, id, comentario_id, publicacion_id}
          })
          commit('SET_ERROR_SAVING_COMMENT', false)
          commit('SET_UNSAVED_COMENTARIO_DATA', null)
          commit('SET_REPLYING_TO_COMMENT', null)
        } else {
          Metro.notify.create(resp.data.error || ' ', 'Error', {cls: "bg-red fg-white"})
          commit('SET_ERROR_SAVING_COMMENT', true)
        }
      }).catch(() => {
        Metro.notify.create('Error', null, {cls: "bg-red fg-white"})
      })
    },
    async checkReactions({ state, getters, commit }, payload) {
      if (!getters.isLoggedIn) {
        return
      }
      const existentReactions = payload.tipo === 'publicaciones' ? state.reaccionesPub : state.reaccionesCom
      const unixNow = Date.now()
      const idsToSearch = payload.ids.reduce((arr,id) => {
        if (!existentReactions[id] || existentReactions[id].expire_time < unixNow) {
          arr.push(id)
        }
        return arr
      }, [])

      if (idsToSearch.length > 0) {
        await axios.get(`api/v2/koinonia10/rs/my-reactions/${payload.tipo}.json`,{
          params: {
            lista: idsToSearch
          }
        }).then(resp => {
          const mutationType = payload.tipo === 'publicaciones' ? 'SET_REACCIONES_PUB' : 'SET_REACCIONES_COM'
          commit(mutationType, resp.data.reacciones)
        }).catch(() => {})
      }
    },
    async setReactionPub({ state, commit, getters }, payload) {
      if (!state.reaccionesPub[payload.id]) {
        commit('SET_REACCIONES_PUB', {[payload.id]: {expire_time: Date.now()}})
      }
      if (state.reaccionesPub[payload.id][getters.vistaActivaId] !== payload.reaction &&
        (state.reaccionesPub[payload.id][getters.vistaActivaId] || payload.reaction)) {

        const responseApi = await axios.post(`api/v2/koinonia10/rs/react/publicacion.json`, {
          entidad_id: payload.id,
          vista_difusion_id: getters.vistaActivaId,
          reaccion: payload.reaction
        })
        if (responseApi.data.ok) {
          commit(
            'SET_REACCION_TO_PUB', {publicacionId: payload.id, reaccion: {[getters.vistaActivaId]: payload.reaction}}
          )
          return responseApi.data.cantidad_reacciones
        } else {
          Metro.notify.create('Error', null, {cls: "bg-red fg-white"})
        }
      }
    },
    async setReactionCom({ state, commit, getters }, payload) {
      if (!state.reaccionesCom[payload.id]) {
        commit('SET_REACCIONES_COM', {[payload.id]: {expire_time: Date.now()}})
      }
      if (state.reaccionesCom[payload.id][getters.vistaActivaId] !== payload.reaction &&
        (state.reaccionesCom[payload.id][getters.vistaActivaId] || payload.reaction)) {

        const responseApi = await axios.post(`api/v2/koinonia10/rs/react/comentario.json`, {
          entidad_id: payload.id,
          vista_difusion_id: getters.vistaActivaId,
          reaccion: payload.reaction
        })
        if (responseApi.data.ok) {
          commit(
            'SET_REACCION_TO_COM', {comentarioId: payload.id, reaccion: {[getters.vistaActivaId]: payload.reaction}}
          )
          return responseApi.data.cantidad_reacciones
        } else {
          Metro.notify.create('Error', null, {cls: "bg-red fg-white"})
        }
      }
    },
    async refreshState({ commit }) {
      commit('SET_SHOW_SIDE_NAV', false)
      commit('SET_LOADED_ALL_VISTAS', false)
      commit('SET_PUBK10_DISPONIBLES', null)
      commit('SET_PATROCINADOR_K10_DATA', null)
      commit('SET_VISTAS_DIFUSION_RS', {})
      commit('SET_UNSAVED_COMENTARIO_DATA',null)
      commit('SET_ERROR_SAVING_COMMENT', false)
      commit('SET_REPLYING_TO_COMMENT', null)
      commit('SET_INTRINSIC_REPLY_TO', null)
      commit('DELETE_REACCIONES')
    },
    async logoutActions({ commit, dispatch }) {
      // Lo mismo que en refresh state
      commit('SET_SHOW_SIDE_NAV', false)
      commit('SET_LOADED_ALL_VISTAS', false)
      commit('SET_PUBK10_DISPONIBLES', null)
      commit('SET_PATROCINADOR_K10_DATA', null)
      commit('SET_UNSAVED_COMENTARIO_DATA',null)
      commit('SET_ERROR_SAVING_COMMENT', false)
      commit('SET_REPLYING_TO_COMMENT', null)
      commit('SET_INTRINSIC_REPLY_TO', null)
      commit('DELETE_REACCIONES')

      commit('SET_ALL_VISTAS',{})
      dispatch('updateVistaActivaId',null)
    }
  }
}